import { connect } from 'react-redux';
import SixSenseActivationView from './SixSenseActivationView.jsx';
import { activateAccount } from 'src/legacy/redux/actions/integrations/sixSense.jsx';
import {trackAdoptionMetricsForPluginConnectedEvent} from 'src/legacy/redux/actions/adoption';
import _ from 'lodash';

const mapStateToProps = (state, ownProps) => {
  return {
    activating: _.get(state.legacyRootReducer, "settings.integrations.sixthSense.activation.activating"),
    error: _.get(state.legacyRootReducer, "settings.integrations.sixthSense.activation.error")
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    activateAccount : (configuration) => {
        return dispatch(activateAccount(configuration))
    },
    trackAdoptionMetricsForPluginConnectedEvent: (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
  }
}

const SixSenseActivationPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SixSenseActivationView);

export default SixSenseActivationPage;
